import React, { useContext, useMemo } from "react";
import Card from "./Card";
import classes from "./CardContainer.module.css";
import { OutputContext } from "../../../shared/contexts/OutputContext";
import LoadingSpinner from "../../general/LoadingSpinner";
import { getComparison } from "../../../shared/utils/getComparison";

const CardContainer = ({
  scheme,
  retirementType,
  hoveredBenefitType,
  onMouseEnter,
  onMouseLeave,
  onCardClick,
  filterDate,
}) => {
  const { outputs, loading } = useContext(OutputContext);

  const filteredData = useMemo(() => {
    if (!loading) {
      return outputs.filter(
        (card) =>
          card.retirementType === retirementType &&
          card.remedyChoice === scheme.remedyChoice &&
          card.date === filterDate
      );
    }
  }, [outputs, retirementType, scheme.remedyChoice, filterDate]);

  const comparisons = useMemo(() => {
    if (!loading) {
      return filteredData.map((card) => ({
        id: card.id,
        comparisonArray: getComparison(
          card,
          outputs.filter((item) => item.date === filterDate)
        ),
      }));
    }
  }, [filteredData, outputs, filterDate]);

  return (
    <div className={classes.group_container}>
      <h3>{scheme.title}</h3>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={classes.card_row}>
          {filteredData.map((card) => (
            <Card
              key={card.id}
              card={card}
              isHovered={hoveredBenefitType === card.benefitType}
              onMouseEnter={() => onMouseEnter(card.benefitType)}
              onMouseLeave={onMouseLeave}
              onClick={() => onCardClick(card.benefitType)}
              comparisonArray={
                comparisons.find((comparison) => comparison.id === card.id)
                  ?.comparisonArray || []
              }
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(CardContainer);
